// in polyfills.ts
import './zone-flags';

// Polyfill for crypto.randomUUID for environments where it's not available (e.g., Playwright, older browsers)
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  // @ts-ignore
  crypto.randomUUID = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}

